// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1ZXKg","rootCenter":"LoadMoreObserver_rootCenter__1zmEB","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2acdH"};